const modelName = 'Cruise Lines';
const modelNameSingular = 'Cruise Line';
const endpoint = '/cruise-lines';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: false,
  canSearch: true,
  endpoint,
  accessor: 'id',
};

export default setup;
